<div class="sell-property-container bg-gray-50 min-h-screen">
  <!-- Hero Section -->
  <section class="bg-gradient-to-r from-immovea-navy via-blue-800 to-blue-900 text-white py-12 sm:py-20 lg:py-24">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="max-w-3xl">
        <h1 class="text-4xl sm:text-5xl font-bold mb-3 sm:mb-4">Sell Your Property</h1>
        <p class="text-base sm:text-xl text-blue-100 leading-relaxed">Let us help you sell your property quickly and at the best price. Share your property details and our experts will reach out to you.</p>
      </div>
    </div>
  </section>

  <div class="max-w-5xl mx-auto py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
    <div class="bg-white rounded-xl shadow-2xl overflow-hidden">
      <!-- Form Header -->
      <div class="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 sm:px-8 py-6 border-b-2 border-indigo-200">
        <h2 class="text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-3">
          <svg class="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
          </svg>
          List Your Property
        </h2>
        <p class="text-gray-600 mt-2">Provide details about your property and we'll contact you within 24 hours</p>
      </div>

      <form (ngSubmit)="submitForm()" class="px-6 sm:px-8 py-8 space-y-6">
        <!-- Personal Information Section -->
        <div class="space-y-6">
          <h3 class="text-lg font-bold text-gray-900 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
            <svg class="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
            </svg>
            Personal Information
          </h3>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            <!-- Name -->
            <div>
              <label for="name" class="block text-sm font-semibold text-gray-900 mb-2">
                Full Name <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                [(ngModel)]="name"
                name="name"
                placeholder="Rami Nassar"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['name'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['name']" class="text-sm text-red-600 mt-1">{{ errors()['name'] }}</p>
            </div>

            <!-- Email -->
            <div>
              <label for="email" class="block text-sm font-semibold text-gray-900 mb-2">
                Email Address <span class="text-red-500">*</span>
              </label>
              <input
                type="email"
                id="email"
                [(ngModel)]="email"
                name="email"
                placeholder="rami@example.com"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['email'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['email']" class="text-sm text-red-600 mt-1">{{ errors()['email'] }}</p>
            </div>
          </div>

          <!-- Phone -->
          <div class="grid grid-cols-3 gap-3 sm:gap-4">
            <div>
              <label for="country_code" class="block text-sm font-semibold text-gray-900 mb-2">
                Code <span class="text-red-500">*</span>
              </label>
              <select
                id="country_code"
                [(ngModel)]="country_code"
                name="country_code"
                [class]="'w-full px-3 sm:px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['country_code'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              >
                <option *ngFor="let country of countryCodes" [value]="country.code">
                  {{ country.flag }} {{ country.code }}
                </option>
              </select>
              <p *ngIf="errors()['country_code']" class="text-xs text-red-600 mt-1">{{ errors()['country_code'] }}</p>
            </div>

            <div class="col-span-2">
              <label for="phone" class="block text-sm font-semibold text-gray-900 mb-2">
                Phone Number <span class="text-red-500">*</span>
              </label>
              <input
                type="tel"
                id="phone"
                [(ngModel)]="phone"
                name="phone"
                placeholder="01-234-567"
                [class]="'w-full px-3 sm:px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['phone'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['phone']" class="text-xs text-red-600 mt-1">{{ errors()['phone'] }}</p>
            </div>
          </div>
        </div>

        <!-- Property Details Section -->
        <div class="space-y-6">
          <h3 class="text-lg font-bold text-gray-900 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
            <svg class="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
            </svg>
            Property Details
          </h3>

          <!-- Property Type -->
          <div>
            <label for="propertyType" class="block text-sm font-semibold text-gray-900 mb-2">
              Property Type <span class="text-red-500">*</span>
            </label>
            <select
              id="propertyType"
              [(ngModel)]="propertyType"
              name="propertyType"
              [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['propertyType'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
              required
            >
                <option value="Apartment">🏢 Apartment</option>
                <option value="Villa">🏡 Villa</option>
                <option value="Land">🌳 Land</option>
                <optgroup label="🏪 Commercial">
                  <option value="Commercial - Office">📋 Office</option>
                  <option value="Commercial - Warehouse">📦 Warehouse</option>
                  <option value="Commercial - Shop">🛍️ Shop</option>
                  <option value="Commercial - Industrial Land">🏭 Industrial Land</option>
                  <option value="Commercial - Building">🏢 Building</option>
                  <option value="Commercial - Showroom">🎪 Showroom</option>
            </select>
            <p *ngIf="errors()['propertyType']" class="text-sm text-red-600 mt-1">{{ errors()['propertyType'] }}</p>
          </div>

          <!-- Address -->
          <div>
            <label for="address" class="block text-sm font-semibold text-gray-900 mb-2">
              Street Address <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="address"
              [(ngModel)]="address"
              name="address"
              placeholder="Rue Gouraud, Mar Mikhael"
              [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['address'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
              required
            />
            <p *ngIf="errors()['address']" class="text-sm text-red-600 mt-1">{{ errors()['address'] }}</p>
          </div>

          <!-- City, State, ZIP -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
            <div>
              <label for="city" class="block text-sm font-semibold text-gray-900 mb-2">
                City <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="city"
                [(ngModel)]="city"
                name="city"
                placeholder="Beirut"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['city'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['city']" class="text-sm text-red-600 mt-1">{{ errors()['city'] }}</p>
            </div>

            <div>
              <label for="state" class="block text-sm font-semibold text-gray-900 mb-2">
                State <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="state"
                [(ngModel)]="state"
                name="state"
                placeholder="Mount Lebanon"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['state'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['state']" class="text-sm text-red-600 mt-1">{{ errors()['state'] }}</p>
            </div>

            <div>
              <label for="zipCode" class="block text-sm font-semibold text-gray-900 mb-2">
                ZIP Code <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="zipCode"
                [(ngModel)]="zipCode"
                name="zipCode"
                placeholder="1107 2810"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['zipCode'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['zipCode']" class="text-sm text-red-600 mt-1">{{ errors()['zipCode'] }}</p>
            </div>
          </div>

          <!-- Property Features -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            <div>
              <label for="bedrooms" class="block text-sm font-semibold text-gray-900 mb-2">
                Bedrooms
              </label>
              <input
                type="number"
                id="bedrooms"
                [(ngModel)]="bedrooms"
                name="bedrooms"
                placeholder="3"
                min="0"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>

            <div>
              <label for="bathrooms" class="block text-sm font-semibold text-gray-900 mb-2">
                Bathrooms
              </label>
              <input
                type="number"
                id="bathrooms"
                [(ngModel)]="bathrooms"
                name="bathrooms"
                placeholder="2"
                min="0"
                step="0.5"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>

            <div>
              <label for="squareFeet" class="block text-sm font-semibold text-gray-900 mb-2">
                Square Meters
              </label>
              <input
                type="number"
                id="squareFeet"
                [(ngModel)]="squareFeet"
                name="squareFeet"
                placeholder="1500"
                min="0"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>

            <div>
              <label for="yearBuilt" class="block text-sm font-semibold text-gray-900 mb-2">
                Year Built
              </label>
              <input
                type="number"
                id="yearBuilt"
                [(ngModel)]="yearBuilt"
                name="yearBuilt"
                placeholder="2010"
                min="1800"
                max="2025"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
          </div>

          <!-- Estimated Value -->
          <div>
            <label for="currentValue" class="block text-sm font-semibold text-gray-900 mb-2">
              Estimated Property Value
            </label>
            <input
              type="text"
              id="currentValue"
              [(ngModel)]="currentValue"
              name="currentValue"
              placeholder="$250,000"
              class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
            />
            <p class="text-xs text-gray-500 mt-1">Optional: Your estimate of the property's current market value</p>
          </div>

          <!-- Additional Property Details Section -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mt-6">
            <div>
              <label for="neighborhood" class="block text-sm font-semibold text-gray-900 mb-2">
                Neighborhood
              </label>
              <input
                type="text"
                id="neighborhood"
                [(ngModel)]="neighborhood"
                name="neighborhood"
                placeholder="e.g., Achrafieh, Verdun, Hamra"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>

            <div>
              <label for="floor" class="block text-sm font-semibold text-gray-900 mb-2">
                Floor Number
              </label>
              <input
                type="number"
                id="floor"
                [(ngModel)]="floor"
                name="floor"
                placeholder="3"
                min="0"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>

            <div>
              <label for="parkingCovered" class="block text-sm font-semibold text-gray-900 mb-2">
                Covered Parking Spots
              </label>
              <input
                type="number"
                id="parkingCovered"
                [(ngModel)]="parkingCovered"
                name="parkingCovered"
                placeholder="0"
                min="0"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>

            <div>
              <label for="parkingOutdoor" class="block text-sm font-semibold text-gray-900 mb-2">
                Outdoor Parking Spots
              </label>
              <input
                type="number"
                id="parkingOutdoor"
                [(ngModel)]="parkingOutdoor"
                name="parkingOutdoor"
                placeholder="0"
                min="0"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>

            <div class="md:col-span-2">
              <label for="generalCondition" class="block text-sm font-semibold text-gray-900 mb-2">
                General Condition
              </label>
              <select
                id="generalCondition"
                [(ngModel)]="generalCondition"
                name="generalCondition"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              >
                <option value="">Select condition</option>
                <option value="excellent">Excellent</option>
                <option value="good">Good</option>
                <option value="fair">Fair</option>
                <option value="needs_work">Needs Work</option>
                <option value="renovation_required">Renovation Required</option>
              </select>
            </div>
          </div>

          <!-- Property Features Checkboxes -->
          <div class="mt-6">
            <label class="block text-sm font-semibold text-gray-900 mb-3">
              Property Features
            </label>
            <div class="grid grid-cols-2 md:grid-cols-3 gap-3">
              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  type="checkbox"
                  [(ngModel)]="hasElevator"
                  name="hasElevator"
                  class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span class="text-sm text-gray-700 group-hover:text-gray-900">Elevator</span>
              </label>

              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  type="checkbox"
                  [(ngModel)]="hasTerrace"
                  name="hasTerrace"
                  class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span class="text-sm text-gray-700 group-hover:text-gray-900">Terrace</span>
              </label>

              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  type="checkbox"
                  [(ngModel)]="hasGarden"
                  name="hasGarden"
                  class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span class="text-sm text-gray-700 group-hover:text-gray-900">Garden</span>
              </label>

              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  type="checkbox"
                  [(ngModel)]="hasView"
                  name="hasView"
                  class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span class="text-sm text-gray-700 group-hover:text-gray-900">View</span>
              </label>

              <label class="flex items-center gap-2 cursor-pointer group">
                <input
                  type="checkbox"
                  [(ngModel)]="isFurnished"
                  name="isFurnished"
                  class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span class="text-sm text-gray-700 group-hover:text-gray-900">Furnished</span>
              </label>
            </div>
          </div>

          <!-- Additional Information -->
          <div>
            <label for="additionalInfo" class="block text-sm font-semibold text-gray-900 mb-2">
              Additional Information
            </label>
            <textarea
              id="additionalInfo"
              [(ngModel)]="additionalInfo"
              name="additionalInfo"
              rows="4"
              placeholder="Tell us more about your property, recent renovations, special features, etc."
              class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg bg-gray-50 hover:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition resize-none"
            ></textarea>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="pt-4">
          <button
            type="submit"
            [disabled]="isSubmitting()"
            class="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-4 px-6 rounded-lg font-semibold text-lg hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
          >
            <svg *ngIf="!isSubmitting()" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <svg *ngIf="isSubmitting()" class="animate-spin h-6 w-6" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ isSubmitting() ? 'Submitting...' : 'Submit Property Information' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
